import { useState } from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileSpreadsheet } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { PayrollProcessor } from '@/components/payroll/PayrollProcessor';

const Payroll = () => {
  const [selectedMonth, setSelectedMonth] = useState(() => new Date().toISOString().substring(0, 7));

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold">Payroll Management</h1>
            <p className="text-gray-500">Process payroll for a selected month</p>
          </div>
          <div className="flex items-center gap-2">
            <Label htmlFor="payrollMonth">Month</Label>
            <Input
              id="payrollMonth"
              type="month"
              value={selectedMonth}
              onChange={e => setSelectedMonth(e.target.value)}
              className="w-40"
            />
          </div>
        </div>

        <Card className="w-full">
          <CardHeader className="flex flex-row items-center justify-between">
            <div>
              <CardTitle className="text-xl">Bulk Processing</CardTitle>
              <CardDescription>Run payroll for {selectedMonth}</CardDescription>
            </div>
            <Button className="bg-payroll-primary hover:bg-blue-700" size="sm">
              <FileSpreadsheet className="h-4 w-4 mr-2" />
              Batch Process
            </Button>
          </CardHeader>
          <CardContent className="pt-0">
            <div className="w-full">
              <PayrollProcessor />
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Payroll;
